import React, { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/text';

export interface RecommendationCardProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  features: {
    icon: ReactNode;
    features: string[];
  };
  description?: ReactNode;
  cta: ReactNode;
  isRecommended?: boolean;
}

export const RecommendationCard = ({
  icon,
  title,
  subtitle,
  features,
  description,
  cta,
  isRecommended,
}: RecommendationCardProps) => {
  return (
    <div
      className={cn(
        'shadow-card border-neutral-N10 relative flex flex-col border dark:shadow-none',
        !isRecommended && 'rounded-3xl',
        isRecommended && 'rounded-b-3xl'
      )}
    >
      {isRecommended && (
        <div className='bg-neutral-N10 absolute -top-8 w-full shrink-0 rounded-t-3xl px-2 py-1 text-center uppercase'>
          <Text
            classNames={{
              wrapper: 'tracking-widest',
            }}
            color='neutral-N80'
          >
            Recommended
          </Text>
        </div>
      )}
      <div className='flex grow flex-col gap-y-8 p-8 md:gap-y-9 md:p-9'>
        <div className='flex items-center gap-x-4'>
          {!!icon && icon}
          <div className='flex flex-col items-start gap-y-3'>
            <Text variant='subtitle-l'>{title}</Text>
            {!!subtitle && <Text variant='subtitle-l'>{subtitle}</Text>}
          </div>
        </div>
        <ul className='space-y-3'>
          {features.features.map((feature) => (
            <li className='flex gap-x-3 text-left' key={feature}>
              {!!features.icon && features.icon}
              <Text variant='body-l'>{feature}</Text>
            </li>
          ))}
        </ul>
        {!!description && (
          <div className='text-neutral-N50 grow text-left'>{description}</div>
        )}
        {cta && <div data-tracker-component='action'>{cta}</div>}
      </div>
    </div>
  );
};
